<template>
  <main class="career-page">
    <section class="career-hero" v-reveal>
      <div>
        <p class="section-kicker">{{ career.kicker }}</p>
        <h1>{{ career.title }}</h1>
        <p>{{ career.copy }}</p>
        <div class="hero-actions">
          <a
            class="action-button action-button--discord action-button--large"
            :href="career.primaryAction.href"
          >
            <AppIcon :name="career.primaryAction.icon" />
            <span>{{ career.primaryAction.label }}</span>
          </a>
          <a
            class="action-button action-button--muted action-button--large"
            :href="career.secondaryAction.href"
          >
            <AppIcon :name="career.secondaryAction.icon" />
            <span>{{ career.secondaryAction.label }}</span>
          </a>
        </div>
      </div>

      <PageMascotVisual />
    </section>

    <section class="career-notice" v-reveal>
      <span>
        <AppIcon name="lock" />
      </span>
      <div>
        <h2>{{ career.ndaNotice.title }}</h2>
        <p>{{ career.ndaNotice.copy }}</p>
      </div>
    </section>

    <section :id="career.primaryAction.href.replace('#', '')" class="career-openings" v-reveal>
      <div class="section-heading">
        <p class="section-kicker">{{ career.openingsTitle }}</p>
      </div>
      <div class="career-opening-grid">
        <a
          v-for="(opening, index) in career.openings"
          :key="opening.title"
          class="career-opening-card"
          :href="`/karriere/${opening.slug}`"
          :style="{ '--delay': `${index * 100}ms` }"
        >
          <span class="career-opening-card__icon">
            <AppIcon :name="opening.icon" />
          </span>
          <h2>{{ opening.title }}</h2>
          <p>{{ opening.copy }}</p>
          <div>
            <strong v-for="tag in opening.tags" :key="tag">{{ tag }}</strong>
          </div>
        </a>
      </div>
    </section>

    <section class="career-beta-teaser" v-reveal>
      <span>
        <AppIcon :name="career.betaTeaser.icon" />
      </span>
      <div>
        <h2>{{ career.betaTeaser.title }}</h2>
        <p>{{ career.betaTeaser.copy }}</p>
      </div>
      <a class="action-button action-button--muted" :href="career.betaTeaser.href">
        <AppIcon name="chevron" />
        <span>{{ career.betaTeaser.action }}</span>
      </a>
    </section>

    <section class="career-steps" v-reveal>
      <div class="section-heading section-heading--center">
        <p class="section-kicker">{{ career.stepsTitle }}</p>
      </div>
      <div class="career-step-grid">
        <article v-for="step in career.steps" :key="step.number">
          <span>{{ step.number }}</span>
          <h2>{{ step.title }}</h2>
          <p>{{ step.copy }}</p>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'
import PageMascotVisual from './PageMascotVisual.vue'

export default {
  name: 'CareerPage',
  components: {
    AppIcon,
    PageMascotVisual
  },
  props: {
    career: {
      type: Object,
      required: true
    }
  }
}
</script>
